import { findIndex } from 'lodash'

const initialState = {
  id: -1,
  type: '',
  open: false,
  containsGel: false,
  on: false,
  gelExamined: false,
  showToolTipControls: false,
  showControlsModal: false
};

// export default (state = initialState, action) => {
export default (state = initialState, action) => {
  let currentTransilluminator;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
      return state;
  }

  if (action.type !== "CREATE_TRANSILLUMINATOR" && !action.type.includes("@redux")) {
    if(action.payload.hasOwnProperty("id")){
          if(state.protocolSection.scene.apparatus.hasOwnProperty("transilluminator")){
            currentTransilluminator = state.protocolSection.scene.apparatus.transilluminator[findIndex(state.protocolSection.scene.apparatus.transilluminator, { id: action.payload.id })]
          }
      }
  }
  switch (action.type) {
    case 'CREATE_TRANSILLUMINATOR':

      //Create new obj from template state
      let newObj = { ...initialState, ...action.payload.props }

      if(protocolSection.scene.apparatus.hasOwnProperty("transilluminator")){
        protocolSection.scene.apparatus.transilluminator = [ ...protocolSection.scene.apparatus.transilluminator, newObj ]
      } else {
        protocolSection.scene.apparatus.transilluminator = [newObj]
      }

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case 'TURN_ON_TRANSILLUMINATOR':
      currentTransilluminator.on = action.payload.on
      protocolSection.scene.apparatus.transilluminator[findIndex(state.transilluminator, { id: action.payload.id })] = currentTransilluminator

      return { ...state, ...{
        protocolSection: protocolSection
      } }


    case 'PLACE_GEL_ON_TRANSILLUMINATOR':
      currentTransilluminator.containsGel = action.payload.containsGel
      protocolSection.scene.apparatus.transilluminator[findIndex(state.transilluminator, { id: action.payload.id })] = currentTransilluminator

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case 'TRANSILLUMINATOR_TOGGLE_CONTROLS_MODAL':
      currentTransilluminator.showControlsModal = action.payload.showControlsModal
      protocolSection.scene.apparatus.transilluminator[findIndex(state.transilluminator, { id: action.payload.id })] = currentTransilluminator

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "TRANSILLUMINATOR_OPEN":
      currentTransilluminator.open = action.payload.open
      protocolSection.scene.apparatus.transilluminator[findIndex(state.transilluminator, { id: action.payload.id })] = currentTransilluminator

      return { ...state, ...{
        protocolSection: protocolSection
      } }
      case "SHOW_TOOL_TIP_TRANSILLUMINATOR_CONTROLS":
        //Payload = {containsGel}
        currentTransilluminator.showToolTipControls = action.payload.showToolTipControls;

        protocolSection.scene.apparatus.transilluminator[
          findIndex(protocolSection.scene.apparatus.transilluminator, {
            id: action.payload.id,
          })
        ] = currentTransilluminator;
        return {
          ...state,
          ...{ transilluminator: protocolSection.scene.apparatus.transilluminator },
        };

    case "TRANSILLUMINATOR_GEL_EXAMINED":
      currentTransilluminator.gelExamined = action.payload.gelExamined
      protocolSection.scene.apparatus.transilluminator[findIndex(state.transilluminator, { id: action.payload.id })] = currentTransilluminator

      return { ...state, ...{
        protocolSection: protocolSection
      } }

    case "UNDO":
      //Payload = {lastState}
    
      if (action.payload.lastState !== null) {
    
        protocolSection.scene.apparatus.transilluminator = action.payload.lastState.scene.apparatus.transilluminator
    
        return { ...state, ...{
          protocolSection: protocolSection
        } }
    
      } else {
        return state;
      }

    default:
      return state;
  }
};
